const pageTabs = {
    OVERVIEW: 'Overview',
    RECOMMENDATIONS: 'Recommendations',
    INSIGHTS: 'Insights',
};

export default pageTabs;
